export default "__VITE_ASSET__vvuSJL_5__"